module.exports = __webpack_public_path__ + "static/ant-financial-logo-2-51e8edb176c75f09b91f238243c303d8.jpeg";